import create from 'zustand';
import api from '../../utils/api';
import useUsersStore from '../profile/useUsersStore';

const initialState = {
  planInfo: '',
  planInfoCurrent: '',
  loading: false,
  error: '',
};

const usePlanStore = create((set) => ({
  planInfo: initialState.planInfo,
  planInfoCurrent: initialState.planInfoCurrent,
  loading: initialState.loading,
  error: initialState.error,

  fetchPlan: async () => {
    set((state) => ({ ...state, loading: true }));
    try {
      const plansListReq = await api.call({
        name: 'getPlans',
      });

      if (plansListReq.status === 200) {
        const userInfo = useUsersStore.getState().userInfo; // Access userInfo from useUsersStore
        let findCurrentPlan = plansListReq.data.data.find((item) => {
          return (
            item.name === userInfo.payment.plan_name &&
            item.duration === userInfo.payment.plan_duration
          );
        });
        if (findCurrentPlan) {
          set((state) => ({
            ...state,
            error: '',
            planInfoCurrent: findCurrentPlan,
          }));
        }
        set((state) => ({
          ...state,
          error: '',
          planInfo: plansListReq.data.data.sort((item, last) => {
            return item.amount - last.amount;
          }),
        }));
      }
    } catch (error) {
      set((state) => ({
        ...state,
        error: error.message,
      }));
    } finally {
      set((state) => ({
        ...state,
        loading: false,
      }));
    }
  },
}));

export default usePlanStore;
